// extracted by mini-css-extract-plugin
export default {"container":"Filters_container__lcQ7X","teams":"Filters_teams__3JSsE","teamList":"Filters_teamList__8bnuA","grouping":"Filters_grouping__8kUdR","icon":"Filters_icon__3SaHe"};